import HEART_BOMB_SPLAT_IMAGE_URL from './heartSplat.png';
export { HEART_BOMB_SPLAT_IMAGE_URL };
export const HEART_BOMB_SPLAT_SPRITESHEET_DATA = {
    frames: {
        'heartSplat0001.png': {
            frame: { x: 768, y: 774, w: 47, h: 48 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 114, y: 245, w: 47, h: 48 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0002.png': {
            frame: { x: 707, y: 455, w: 59, h: 56 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 106, y: 241, w: 59, h: 56 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0003.png': {
            frame: { x: 707, y: 381, w: 72, h: 64 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 98, y: 237, w: 72, h: 64 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0004.png': {
            frame: { x: 1228, y: 983, w: 84, h: 74 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 90, y: 232, w: 84, h: 74 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0005.png': {
            frame: { x: 1206, y: 899, w: 96, h: 82 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 83, y: 228, w: 96, h: 82 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0006.png': {
            frame: { x: 450, y: 288, w: 44, h: 49 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 77, y: 221, w: 44, h: 49 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0007.png': {
            frame: { x: 1255, y: 534, w: 45, h: 49 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 71, y: 213, w: 45, h: 49 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0008.png': {
            frame: { x: 1212, y: 1183, w: 124, h: 91 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 66, y: 205, w: 124, h: 91 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0009.png': {
            frame: { x: 1215, y: 581, w: 138, h: 105 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 62, y: 196, w: 138, h: 105 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0010.png': {
            frame: { x: 1058, y: 1183, w: 152, h: 119 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 58, y: 187, w: 152, h: 119 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0011.png': {
            frame: { x: 651, y: 1057, w: 165, h: 134 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 55, y: 178, w: 165, h: 134 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0012.png': {
            frame: { x: 1, y: 1171, w: 176, h: 149 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 52, y: 169, w: 176, h: 149 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0013.png': {
            frame: { x: 845, y: 995, w: 188, h: 107 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 49, y: 160, w: 188, h: 107 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0014.png': {
            frame: { x: 859, y: 1193, w: 197, h: 107 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 47, y: 151, w: 197, h: 107 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0015.png': {
            frame: { x: 1008, y: 581, w: 205, h: 105 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 45, y: 142, w: 205, h: 105 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0016.png': {
            frame: { x: 197, y: 1139, w: 213, h: 103 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 42, y: 133, w: 213, h: 103 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0017.png': {
            frame: { x: 845, y: 774, w: 219, h: 176 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 40, y: 123, w: 219, h: 176 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0018.png': {
            frame: { x: 768, y: 474, w: 225, h: 190 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 38, y: 113, w: 225, h: 190 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0019.png': {
            frame: { x: 474, y: 381, w: 231, h: 203 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 36, y: 104, w: 231, h: 203 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0020.png': {
            frame: { x: 780, y: 255, w: 236, h: 217 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 35, y: 94, w: 236, h: 217 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0021.png': {
            frame: { x: 535, y: 586, w: 240, h: 231 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 34, y: 84, w: 240, h: 231 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0022.png': {
            frame: { x: 256, y: 345, w: 245, h: 216 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 32, y: 74, w: 245, h: 216 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0023.png': {
            frame: { x: 422, y: 852, w: 248, h: 220 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 31, y: 64, w: 248, h: 220 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0024.png': {
            frame: { x: 197, y: 885, w: 252, h: 223 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 30, y: 55, w: 252, h: 223 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0025.png': {
            frame: { x: 644, y: 828, w: 227, h: 199 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 58, y: 72, w: 227, h: 199 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0026.png': {
            frame: { x: 1018, y: 345, w: 234, h: 235 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 53, y: 60, w: 234, h: 235 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0027.png': {
            frame: { x: 780, y: 1, w: 241, h: 252 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 48, y: 47, w: 241, h: 252 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0028.png': {
            frame: { x: 530, y: 1, w: 248, h: 269 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 43, y: 35, w: 248, h: 269 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0029.png': {
            frame: { x: 1, y: 305, w: 253, h: 285 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 39, y: 23, w: 253, h: 285 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0030.png': {
            frame: { x: 1, y: 1, w: 260, h: 302 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 34, y: 11, w: 260, h: 302 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0031.png': {
            frame: { x: 263, y: 1, w: 265, h: 285 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 30, y: 0, w: 265, h: 285 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0032.png': {
            frame: { x: 422, y: 1102, w: 227, h: 105 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 26, y: 173, w: 227, h: 105 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0033.png': {
            frame: { x: 768, y: 666, w: 238, h: 106 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 22, y: 165, w: 238, h: 106 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0034.png': {
            frame: { x: 530, y: 272, w: 248, h: 107 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 18, y: 157, w: 248, h: 107 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0035.png': {
            frame: { x: 380, y: 592, w: 258, h: 153 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 14, y: 149, w: 258, h: 153 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0036.png': {
            frame: { x: 211, y: 592, w: 266, h: 167 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 11, y: 140, w: 266, h: 167 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0037.png': {
            frame: { x: 1023, y: 162, w: 276, h: 181 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 7, y: 132, w: 276, h: 181 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0038.png': {
            frame: { x: 1, y: 885, w: 284, h: 194 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 4, y: 124, w: 284, h: 194 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0039.png': {
            frame: { x: 1, y: 592, w: 291, h: 208 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 1, y: 116, w: 291, h: 208 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0040.png': {
            frame: { x: 1023, y: 1, w: 297, h: 159 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 108, w: 297, h: 159 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0041.png': {
            frame: { x: 1215, y: 721, w: 176, h: 101 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 126, y: 155, w: 176, h: 101 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0042.png': {
            frame: { x: 1023, y: 891, w: 181, h: 98 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 125, y: 147, w: 181, h: 98 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0043.png': {
            frame: { x: 1116, y: 688, w: 187, h: 97 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 123, y: 138, w: 187, h: 97 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0044.png': {
            frame: { x: 1035, y: 991, w: 191, h: 95 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 123, y: 129, w: 191, h: 95 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0045.png': {
            frame: { x: 1035, y: 1088, w: 196, h: 93 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 122, y: 120, w: 196, h: 93 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0046.png': {
            frame: { x: 1023, y: 688, w: 201, h: 91 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 121, y: 111, w: 201, h: 91 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0047.png': {
            frame: { x: 651, y: 1193, w: 206, h: 90 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 120, y: 102, w: 206, h: 90 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0048.png': {
            frame: { x: 412, y: 1209, w: 210, h: 88 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 119, y: 93, w: 210, h: 88 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0049.png': {
            frame: { x: 818, y: 1104, w: 213, h: 87 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 118, y: 83, w: 213, h: 87 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0050.png': {
            frame: { x: 389, y: 288, w: 55, h: 59 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 118, y: 100, w: 55, h: 59 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0051.png': {
            frame: { x: 179, y: 1244, w: 56, h: 60 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 117, y: 88, w: 56, h: 60 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0052.png': {
            frame: { x: 237, y: 1244, w: 56, h: 60 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 116, y: 76, w: 56, h: 60 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0053.png': {
            frame: { x: 1255, y: 345, w: 56, h: 61 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 115, y: 64, w: 56, h: 61 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0054.png': {
            frame: { x: 263, y: 288, w: 55, h: 61 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 115, y: 52, w: 55, h: 61 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0055.png': {
            frame: { x: 1255, y: 408, w: 56, h: 61 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 114, y: 40, w: 56, h: 61 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0056.png': {
            frame: { x: 707, y: 513, w: 56, h: 62 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 113, y: 28, w: 56, h: 62 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0057.png': {
            frame: { x: 326, y: 288, w: 55, h: 61 },
            rotated: true,
            trimmed: true,
            spriteSourceSize: { x: 113, y: 17, w: 55, h: 61 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0058.png': {
            frame: { x: 1255, y: 471, w: 56, h: 61 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 112, y: 5, w: 56, h: 61 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        },
        'heartSplat0059.png': {
            frame: { x: 1018, y: 255, w: 3, h: 3 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 3, h: 3 },
            sourceSize: { w: 331, h: 328 },
            anchor: { x: 0.410876, y: 0.814024 }
        }
    },
    animations: {
        animation: [
            'heartSplat0001.png',
            'heartSplat0002.png',
            'heartSplat0003.png',
            'heartSplat0004.png',
            'heartSplat0005.png',
            'heartSplat0006.png',
            'heartSplat0007.png',
            'heartSplat0008.png',
            'heartSplat0009.png',
            'heartSplat0010.png',
            'heartSplat0011.png',
            'heartSplat0012.png',
            'heartSplat0013.png',
            'heartSplat0014.png',
            'heartSplat0015.png',
            'heartSplat0016.png',
            'heartSplat0017.png',
            'heartSplat0018.png',
            'heartSplat0019.png',
            'heartSplat0020.png',
            'heartSplat0021.png',
            'heartSplat0022.png',
            'heartSplat0023.png',
            'heartSplat0024.png',
            'heartSplat0025.png',
            'heartSplat0026.png',
            'heartSplat0027.png',
            'heartSplat0028.png',
            'heartSplat0029.png',
            'heartSplat0030.png',
            'heartSplat0031.png',
            'heartSplat0032.png',
            'heartSplat0033.png',
            'heartSplat0034.png',
            'heartSplat0035.png',
            'heartSplat0036.png',
            'heartSplat0037.png',
            'heartSplat0038.png',
            'heartSplat0039.png',
            'heartSplat0040.png',
            'heartSplat0041.png',
            'heartSplat0042.png',
            'heartSplat0043.png',
            'heartSplat0044.png',
            'heartSplat0045.png',
            'heartSplat0046.png',
            'heartSplat0047.png',
            'heartSplat0048.png',
            'heartSplat0049.png',
            'heartSplat0050.png',
            'heartSplat0051.png',
            'heartSplat0052.png',
            'heartSplat0053.png',
            'heartSplat0054.png',
            'heartSplat0055.png',
            'heartSplat0056.png',
            'heartSplat0057.png',
            'heartSplat0058.png',
            'heartSplat0059.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.0',
        image: HEART_BOMB_SPLAT_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 1321, h: 1321 },
        scale: '1',
        smartupdate: '$TexturePacker:SmartUpdate:5f1e61792a45b772854021dd4c79d1da:90b49cd55c47b4a322ea6a1800fb2768:668b526b29f6e5c7e5ec79b07dd1475f$'
    }
};
